// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__D5Bnp","top":"styles_top__A8Ywr","left":"styles_left__EfPfL","description":"styles_description__A9As1"};